module.exports = __webpack_public_path__ + "img/betsize_btn.b0279a27.png";